import {olivioLuminaires as luminaires} from '../luminaires/olivioLuminaires';
import {radToDeg, degToRad} from '../components/visual/olivio3d-utils';
import {OlivioLayout} from './olivioLayout';

const conf = {
	...OlivioLayout.conf,

	angleMinOffset: 0,
	verticalMinOffset: 0.3,

	floracion: {
		piccolo: {
			verticalMinOffset: 0.45,
		},
		medioGrande: {
			verticalMinOffset: 0.6,
		},
	},
};

class OlivioSpiralLayout extends OlivioLayout {
	static conf = conf;

	calculate(design, configValues) {
		let amount = configValues.numberOfHeads;
		const branches = [];

		const {angleMin, angleMax, heightMin, heightMax} = this.calculateLimits(design, configValues);

		// console.log('LIMITS', heightMin, heightMax, configValues);
		const housingSize = String(configValues.housingSize).toLowerCase().includes('piccolo') ? 'piccolo' : 'medioGrande';
		const angleMinOffset = this.getConfValue('angleMinOffset', [design, housingSize]);
		const verticalMinOffset = this.getConfValue('verticalMinOffset', [design, housingSize]);

		const angleRange = angleMax - angleMin;
		const verticalRange = heightMax - heightMin;

		const maxAmountByAngle = angleMinOffset > 0 ? Math.max(1, Math.floor(angleRange / angleMinOffset)) : 1000;
		const maxAmountByHeight = Math.floor(verticalRange / verticalMinOffset) + 1;
		const maxNumberOfHeads = Math.min(maxAmountByAngle, maxAmountByHeight);
		// console.log('MAX NUMBER OF HEADS', {amount, verticalRange, maxNumberOfHeads, maxAmountByAngle, maxAmountByHeight});
		amount = Math.min(amount, maxNumberOfHeads);

		const angleOffset = angleRange / (amount-1);
		const verticalOffset = amount > 1 ? verticalRange / (amount - 1) : 0;

		for (let i = amount-1; i >= 0; i--) {
			const height = Math.round((heightMin + verticalOffset * i) * 1000) / 1000;
			branches.push({
				angle: Math.round(angleMax - angleOffset * i),
				height: height,
			});
		}

		return {
			maxNumberOfHeads: maxNumberOfHeads,
			angleOffset: angleOffset,
			branches: branches
		};
	}

	calculateLimits(design, configValues) {
		const DesignClass = luminaires[design];
		const entry = DesignClass.poleSizes[DesignClass.getPoleId(configValues)];
		return {
			angleMax: Math.max(configValues.angleMax, configValues.angleMin),
			angleMin: Math.min(configValues.angleMax, configValues.angleMin),
			heightMax: Math.min(entry.maxHeight, Math.max(configValues.heightMax, configValues.heightMin)),
			heightMin: Math.min(entry.maxHeight, configValues.heightMax, configValues.heightMin),
		};
	}
}

export {OlivioSpiralLayout};
